export default __webpack_public_path__ + "static/media/bg2.527c53a8.png";